module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_11"
  }, [_c('i', {
    staticClass: "calibre1"
  }, [_vm._v("History is a set of lies agreed upon."), _c('br', {
    staticClass: "calibre4"
  })]), _c('span', {
    staticClass: "text_1"
  }, [_vm._v(" – Napoléon Bonaparte")])]), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_15"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }, [_vm._v("Man is not what he thinks he is. He is what he hides. ")]), _vm._v(" "), _c('p', {
    staticClass: "block_13"
  }, [_vm._v("– André Malraux"), _c('br', {
    staticClass: "calibre4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_17",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60a93162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 75
// module chunks = 0